export default __webpack_public_path__ + "static/media/pin-round.db4c9eab.svg";